import React, { useEffect, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery } from '@mui/material';

const CuttingItemView = () => {
    const [formData, setFormData] = useState([]);
    const isDesktop = useMediaQuery('(min-width:768px)');
    useEffect(() => {
        // Retrieve the URL parameters
        const query = new URLSearchParams(window.location.search);
        const formParam = query.get('form');

        if (formParam) {
            try {
                // Parse the form data
                const parsedForm = JSON.parse(decodeURIComponent(formParam));
                setFormData(parsedForm);
            } catch (error) {
                console.error('Error parsing form data:', error);
            }
        }
    }, []);


    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };

    console.log(formData);

    return (
        <>
            <div style={{ margin: '1% 0%', width: '100%' }}>

                <h3 className='centered-heading'>Cutting Item View</h3>
                <div className="dashed-line"></div>

                <table style={{ margin: '1% 5%', fontSize: '14px' }}>

                    <tbody>

                        <tr>
                            <td style={{ width: '200px' }}>Item Name</td>
                            <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>{formData.itemNm}</td>
                            <td style={{ width: '200px', paddingLeft: '2%' }}>Total Qty.</td>
                            <td style={{ padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.totQty}</td>
                        </tr>

                        <tr>
                            <td style={{ width: '200px' }}>Main Cloth</td>
                            <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formData.clothNm}</td>
                            <td style={{ width: '100px', paddingLeft: '2%' }}>Given mtr.</td>
                            <td style={{ width: '15vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.mgMtr}</td>
                            <td style={{ width: '100px', paddingLeft: '2%' }}>Required mtr.</td>
                            <td style={{ width: '15vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.mreq}</td>
                        </tr>

                        {
                            formData.mtch1 !== "" &&
                            <tr>
                                <td style={{ width: '200px' }}>Matching-1</td>
                                <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formData.mtch1Nm}</td>
                                <td style={{ width: '100px', paddingLeft: '2%' }}>Given mtr.</td>
                                <td style={{ width: '15vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.m1gMtr}</td>
                                <td style={{ width: '100px', paddingLeft: '2%' }}>Required mtr.</td>
                                <td style={{ width: '15vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.m1req}</td>
                            </tr>
                        }

                        {
                            formData.mtch2 !== "" &&
                            <tr>
                                <td style={{ width: '200px' }}>Matching-2</td>
                                <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formData.mtch2Nm}</td>
                                <td style={{ width: '100px', paddingLeft: '2%' }}>Given mtr.</td>
                                <td style={{ width: '15vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.m2gMtr}</td>
                                <td style={{ width: '100px', paddingLeft: '2%' }}>Required mtr.</td>
                                <td style={{ width: '15vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.m2req}</td>
                            </tr>
                        }

                        {
                            formData.mtch3 !== "" &&
                            <tr>
                                <td style={{ width: '200px' }}>Matching-3</td>
                                <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formData.mtch3Nm}</td>
                                <td style={{ width: '100px', paddingLeft: '2%' }}>Given mtr.</td>
                                <td style={{ width: '15vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.m3gMtr}</td>
                                <td style={{ width: '100px', paddingLeft: '2%' }}>Required mtr.</td>
                                <td style={{ width: '15vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.m3req}</td>
                            </tr>
                        }

                    </tbody>

                </table>

                <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                    <Table>
                        <TableRow>
                            <TableCell className='tbl-row' sx={{ p: 1, border: '1px solid #000', fontSize: '15px', width: '100px' }} align='center'>Size</TableCell>
                            {formData?.itemSize?.length > 0 ? formData?.itemSize?.map((val, index) => (
                                <TableCell key={index} sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{val}</TableCell>
                            )) : null}
                        </TableRow>

                        {formData.ordType === '1' &&
                            (<TableRow>
                                <TableCell className='tbl-row' sx={{ p: 1, border: '1px solid #000', fontSize: '15px', width: '100px' }} align='center'>SO Qty.</TableCell>
                                {formData?.soQty?.length > 0 ? formData?.soQty?.map((val, index) => (
                                    <TableCell key={index} sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{val}</TableCell>
                                )) : null}
                            </TableRow>)
                        }


                        <TableRow>
                            <TableCell className='tbl-row' sx={{ p: 1, border: '1px solid #000', fontSize: '15px', width: '100px' }} align='center'>Qty.</TableCell>
                            {formData?.qtyArr?.length > 0 ? formData?.qtyArr?.map((val, index) => (
                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center' key={index}>
                                    <input
                                        type="text"
                                        style={{ width: '40px', padding: '1px' }}
                                        value={val || '0'}
                                        readOnly
                                    />
                                </TableCell>
                            )) : null}

                        </TableRow>


                        <TableRow>
                            <TableCell className='tbl-row' sx={{ p: 1, border: '1px solid #000', fontSize: '15px', width: '100px' }} align='center'>Main Avg.</TableCell>
                            {formData?.itemMainAvgs?.length > 0 ? formData?.itemMainAvgs?.map((val, index) => (
                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center' key={index}>
                                    {val != '0' ? val :
                                        (<input
                                            type="text"
                                            style={{ width: '40px', padding: '1px' }}
                                            value={val}
                                            readOnly
                                        />)
                                    }
                                </TableCell>
                            )) : null}

                        </TableRow>
                        {formData.mtch1 != '' &&
                            (<TableRow>
                                <TableCell className='tbl-row' sx={{ p: 1, border: '1px solid #000', fontSize: '15px', width: '100px' }} align='center'>M-1 Avg.</TableCell>
                                {formData?.itemM1Avgs?.length > 0 ? formData?.itemM1Avgs?.map((val, index) => (
                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center' key={index}>
                                        {val != '0' ? val :
                                            (<input
                                                type="text"
                                                style={{ width: '40px', padding: '1px' }}
                                                value={val}
                                                readOnly
                                            />)
                                        }
                                    </TableCell>
                                )) : null}

                            </TableRow>)
                        }

                        {formData.mtch2 != '' &&
                            (<TableRow>
                                <TableCell className='tbl-row' sx={{ p: 1, border: '1px solid #000', fontSize: '15px', width: '100px' }} align='center'>M-2 Avg.</TableCell>
                                {formData?.itemM2Avgs?.length > 0 ? formData?.itemM2Avgs?.map((val, index) => (
                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center' key={index}>
                                        {val != '0' ? val :
                                            (<input
                                                type="text"
                                                style={{ width: '40px', padding: '1px' }}
                                                value={val}
                                            />)
                                        }
                                    </TableCell>
                                )) : null}

                            </TableRow>)
                        }

                        {formData.mtch3 != '' &&
                            (<TableRow>
                                <TableCell className='tbl-row' sx={{ p: 1, border: '1px solid #000', fontSize: '15px', width: '100px' }} align='center'>M-3 Avg.</TableCell>
                                {formData?.itemM3Avgs?.length > 0 ? formData?.itemM3Avgs?.map((val, index) => (
                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center' key={index}>
                                        {val != '0' ? val :
                                            (<input
                                                type="text"
                                                style={{ width: '40px', padding: '1px' }}
                                                value={val}
                                            />)
                                        }
                                    </TableCell>
                                )) : null}

                            </TableRow>)
                        }
                    </Table>
                </TableContainer>

            </div>
        </>
    );
};

export default CuttingItemView;
